import React from "react";
import styled from "./styles";
import emojiMap from "../../api/emojis";
import { emojiWs } from "../../api/service";

const emojiList = ["astonished", "heart", "happy", "applause", "thumbsUp"]

const Emoji = (props) => {
  var throttle = function(fn, t) {
    let lastTime = 0;

    return function(...args) {
        const now = Date.now();

        if (now - lastTime >= t) {
            fn(...args);
            lastTime = now;
        }
    };
  };
  
  const emojiButtonClick = throttle((e, type) => {
    e.stopPropagation()
    emojiWs.emit("emojis",{
      action: 'user-clicked',
      name: type
    })
  },300)

  const emojiItem = emojiList.map((item, index)=>{
    return(
      <styled.EmojiListBotton key={index} onClick={(e)=>emojiButtonClick(e, item)}>
        <styled.EmojiImage src={"emojis/" + emojiMap[item]}/>
      </styled.EmojiListBotton>
    )
  })

  return(
    <styled.EmojiListWapper data-test="EmojiList">
      {emojiItem}
    </styled.EmojiListWapper>
  )
}

export default Emoji